<template>
	<div id="canvass">
		<div :class="scrollFlag?'topLan1':'topLan'">
			<img  @click="jumpToIndex" class="CoBrand" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link :class="scrollFlag?'box1':'box'" :to="{path: 'index'}">首页</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'platform'}">电商平台</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'canvass'}">招商入驻
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'about'}">关于我们</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'newsCenter'}">新闻中心</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'recruit'}">人才招聘</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'downLoad'}">下载APP</router-link>
				<!-- <a href="index" class="box1">首页</a>
				<!-- <a href="index" :class="scrollFlag?'box1':'box'">首页</a>
				<a href="platform" :class="scrollFlag?'box1':'box'">电商平台</a>
				<a href="canvass" :class="scrollFlag?'box1':'box'">招商入驻
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</a>
				<a href="about" :class="scrollFlag?'box1':'box'">关于我们</a>
				<a href="newsCenter" :class="scrollFlag?'box1':'box'">新闻中心</a>
				<a href="recruit" :class="scrollFlag?'box1':'box'">人才招聘</a>
				<a href="downLoad" :class="scrollFlag?'box1':'box'">下载APP</a> -->
			</div>
		</div>

		<div id="id1" style="width: 100%;">
			<img style="width: 100%;" mode="widthFix" src="../../static/pic/img_web03_banner1.jpg" />
			<img class="ruzhuBtn" mode="widthFix" src="../../static/pic/btn.png" @click="openDialog()" />
		</div>

		<div id="id2" style="width: 100%;height: 1202px;">
			<div class="section2-titleLan">
				<div class="section2-title">入驻流程</div>
				<div class="section2-line"></div>
			</div>
			<div class="section2Area">
				<img class="section2Pic" mode="widthFix" src="../../static/canvasPic/img_web03_steps.png" />
			</div>
		</div>

		<div id="id3" style="width: 100%;height: 672px;background-color: #F9FDFF;">
			<div class="section2-titleLan">
				<div class="section2-title">平台优势</div>
				<div class="section2-line"></div>
			</div>
			<div class="section3Area">
				<div class="section3SmallArea">
					<img  class="section3Img" src="../../static/canvasPic/img_tab3_3ys.png"/>
					<!-- <div class="section3Box">
						<div class="section3BoxLeft">
							<img class="section3BoxImg" src="../../static/canvasPic/icon_web03_ys1@2x.png" />
						</div>
						<div class="section3BoxRight">
							<div class="section3RightTitle">产品优势</div>
							<div class="section3RighttxtArea">
								<div class="section3RighttxtLan">
									<span style="color: red;">*</span>
									<span
										class="section3Righttxt">0成本开店，帮您把生意搬到线上，让您的顾客随心所欲了解产品，享受一键采购、下单、支付、物流服务。</span>
								</div>
								<div class="section3RighttxtLan">
									<span style="color: red;">*</span>
									<span class="section3Righttxt">无忧对账，帮您告别人工盘账，随时跟踪订单，查询客户往来款项，核对财务明细。</span>
								</div>
								<div class="section3RighttxtLan">
									<span style="color: red;">*</span>
									<span class="section3Righttxt">良好的库存管理，实现在线进销库存管理，帮您优化采购，减少库存积压。</span>
								</div>
								<div class="section3RighttxtLan">
									<span style="color: red;">*</span>
									<span
										class="section3Righttxt">供应链金融服务：平台提供挂账功能，提供蜜蜂白条、蜜蜂贷等业务，帮您实现资金快速回笼，提升资金使用效率。</span>
								</div>
							</div>
						</div>
					</div>
					<div class="section3Box">
						<div class="section3BoxLeft">
							<img class="section3BoxImg1" src="../../static/canvasPic/icon_web03_ys2@2x.png" />
						</div>
						<div class="section3BoxRight">
							<div class="section3RightTitle">市场优势</div>
							<div class="section3RighttxtLan1">
								<span class="section3Righttxt">全方位的渠道宣传，全力度的品牌建设支持</span>
							</div>
							<div class="section3RightTitle">技术优势</div>
							<div class="section3RighttxtLan1">
								<span class="section3Righttxt">技术领先、远程协同、安全性高</span>
							</div>
							<div class="section3RightTitle">团队优势</div>
							<div class="section3RighttxtLan1">
								<span class="section3Righttxt">丰富经验的管理团队、顾问式营销团队、业务领域专家、高效率专业技术团队</span>
							</div>
							<div class="section3RightTitle">服务优势</div>
							<div class="section3RighttxtLan1">
								<span class="section3Righttxt">7×24小时客服、一对一专属顾问、优质的市场指导、完善的售后体系</span>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>

		<div id="id4" style="width: 100%;height: auto;background-color: #E7EEFE;">
			<div class="section2-titleLan">
				<div class="section2-title">平台支持</div>
				<div class="section2-line"></div>
			</div>
			<div class="section4Area">
				<div class="section4SmallArea">
					<div v-if="showPlatFormPic" class="section4Box" @mouseover="changeStyle(1)" @mouseout="changeStyle(0)">
						<img v-show="platFormPic==0" class="section4pic1" src="../../static/canvasPic/icon_zc_a2.png"/>
						<img v-show="platFormPic==1" class="section4pic1" src="../../static/canvasPic/icon_zc_a1.png"/>
						<div v-show="platFormPic==0" class="section4txt">店铺一对一指导运营，帮助商家快速成单，增长销量</div>
						<div v-show="platFormPic==1" class="section4txt1">店铺一对一指导运营，帮助商家快速成单，增长销量</div>
					</div>
					<div v-if="showPlatFormPic1" class="section4Box" @mouseover="changeStyle1(1)" @mouseout="changeStyle1(0)">
						<img v-show="platFormPic1==0" class="section4pic2" src="../../static/canvasPic/icon_zc_b2.png"/>
						<img v-show="platFormPic1==1" class="section4pic2" src="../../static/canvasPic/icon_zc_b1.png"/>
						<div v-show="platFormPic1==0" class="section4txt">提供金融支持蜜蜂白条、蜜蜂挂账，加速商家资金流动</div>
						<div v-show="platFormPic1==1" class="section4txt1">提供金融支持蜜蜂白条、蜜蜂挂账，加速商家资金流动</div>
					</div>
					<div v-if="showPlatFormPic2" class="section4Box" @mouseover="changeStyle2(1)" @mouseout="changeStyle2(0)">
						<img v-show="platFormPic2==0" class="section4pic3" src="../../static/canvasPic/icon_zc_c2.png"/>
						<img v-show="platFormPic2==1" class="section4pic3" src="../../static/canvasPic/icon_zc_c1.png"/>
						<div v-show="platFormPic2==0" class="section4txt">有效整合设备租赁、二手机交易需求等，促进成交</div>
						<div v-show="platFormPic2==1" class="section4txt1">有效整合设备租赁、二手机交易需求等，促进成交</div>
					</div>
					<!-- <div class="section4Box">
						<img class="section4pic2" src="../../static/canvasPic/icon_web03_support2@2x.png" />
						<div class="section4txt">建立一站式仓储服务，商家一键发货</div>
					</div>
					<div class="section4Box">
						<img class="section4pic3" src="../../static/canvasPic/icon_web03_support3@2x.png" />
						<div class="section4txt">平台收取低服务费，甚至免费，让利商家</div>
					</div>
					<div class="section4Box">
						<img class="section4pic4" src="../../static/canvasPic/icon_web03_support4@2x.png" />
						<div class="section4txt">商家定制化功能，满足商家独立功能需求</div>
					</div>
					<div class="section4Box">
						<img class="section4pic5" src="../../static/canvasPic/icon_web03_support4@2x(1).png" />
						<div class="section4txt">帮助商家实现全渠道推广、引流；全方位品牌建设</div>
					</div>
					<div class="section4Box">
						<img class="section4pic6" src="../../static/canvasPic/icon_web03_support6@2x.png" />
						<div class="section4txt">不定期提供运营、技术、管理培训，互利共赢</div>
					</div> -->
				</div>
			</div>
		</div>


		<div id="id5" style="width: 100%;background-color: #F9FDFF;">
			<div class="section2-titleLan">
				<div class="section2-title">合作模式</div>
				<div class="section2-line"></div>
			</div>
			<div class="section5Area">
				
				<div class="section5SmallArea">
					<div class="section5Box">
						<img class="section5Pic1" src="../../static/canvasPic/icon_p3_151.png" />
						<div class="section5txt">招商入驻</div>
						<div class="section5txt1">业务范围：配件、设备租赁、二手机交易、维修、大件物流</div>
					</div>
					<div class="section5Box">
						<img class="section5Pic1" src="../../static/canvasPic/icon_p3_152.png" />
						<div class="section5txt">线上签约</div>
						<div class="section5txt1">线上完成签约流程，收取固定手续费</div>
					</div>
					<div class="section5Box">
						<img class="section5Pic1" src="../../static/canvasPic/icon_p3_153.png" />
						<div class="section5txt">设备管理费</div>
						<div class="section5txt1">硬件费，服务费</div>
					</div>
					<!-- <div class="section5Box">
						<img class="section5Pic2" src="../../static/canvasPic/icon_web03_model2@2x.png" />
						<div class="section5txt">平台每年收取,固定管理费</div>
					</div>
					<div class="section5Box">
						<img class="section5Pic3" src="../../static/canvasPic/icon_web03_model3@2x(1).png" />
						<div class="section5txt">平台按照商家销售额 收取一定比例管理费</div>
					</div> -->
				</div>
				
			</div>
		</div>


		<div id="id6" style="width: 100%;height:1058px;">
			<div class="section2-titleLan">
				<div class="section2-title">资质要求</div>
				<div class="section2-line"></div>
			</div>
			<div class="section6Area">
				<div class="section6SmallArea">
					<div class="section6Box">
						<img class="section6Pic1" src="../../static/canvasPic/icon_web03_zizhi1@2x.png" />
						<div class="section6txt1">营业执照</div>
					</div>
					<div class="section6Box">
						<img class="section6Pic2" src="../../static/canvasPic/icon_web03_zizhi2@2x.png" />
						<div class="section6txt2">法人正反面身份证</div>
					</div>
					<div class="section6Box">
						<img class="section6Pic2" src="../../static/canvasPic/icon_web03_zizhi3@2x.png" />
						<div class="section6txt2">银行开户行证明</div>
					</div>
					<div class="section6Box">
						<img class="section6Pic2" src="../../static/canvasPic/icon_web03_zizhi4@2x.png" />
						<div class="section6txt2">销售授权书</div>
					</div>
				</div>
			</div>
		</div>

		<div id="id7" style="width: 100%;height: 655px;background-color: #F9FDFF;">
			<div class="section2-titleLan">
				<div class="section2-title">下载地址</div>
				<div class="section2-line"></div>
			</div>
			<div class="section7Area">
				<div class="section7SmallArea">
					<div class="section7Box">
						<img class="section7Pic" src="../../static/canvasPic/icon_web03_downdz1@2x.png" />
						<div class="section7txt1">创世蜜蜂商家APP下载地址</div>
						<!-- <div class="section7txt2">http://seller.hudiejx.com/</div> -->
						<!-- <div class="section7PicLan">
							<div class="section7PicLanBox">
								<img class="section7PicBoxImg" src="../../static/download_b_ios@2x.png" />
								<div  class="section7PicBoxtxt">苹果地址</div>
							</div>
							<div class="section7PicLanBox">
								<img class="section7PicBoxImg" src="../../static/download_b_andrid@2x.png"/>
								<div class="section7PicBoxtxt">安卓地址</div>
							</div>
						</div> -->
						<div class="section7PicLan1">
							<div class="section7PicLanBox">
								<img class="section7PicBoxImg" src="../../static/downLoadPic/seller.jpg" />
								<!-- <div  class="section7PicBoxtxt">扫码下载</div> -->
							</div>
							
						</div>
					</div>
					<div class="section7Box">
						<img class="section7Pic" src="../../static/canvasPic/icon_web03_downdz2@2x.png" />
						<div class="section7txt1">商家端管理后台地址</div>
						<div class="section7txt2">http://seller.hudiejx.com/</div>
					</div>
				</div>
			</div>
		</div>


		<bottom-area></bottom-area>

		<el-dialog title="提交信息" custom-class="dialogClass" :visible.sync="open" width="900px">
			<div class="dialogLine"></div>
			<el-form :model="form" :rules="rules" ref="form" style="margin-top: 48px;">
				<el-row :gutter="14">
					<el-col :span="12">
						<el-form-item prop="companyName">
							<div class="dialogBox">
								<div class="inputTitle">公司名称</div>
								<el-input v-model="form.companyName"></el-input>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="name" >
							<div class="dialogBox">
								<div class="inputTitle">姓名</div>
								<el-input v-model="form.name"></el-input>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="tel">
							<div class="dialogBox">
								<div class="inputTitle">电话号码</div>
								<el-input v-model="form.tel"></el-input>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="position">
							<div class="dialogBox">
								<div class="inputTitle">职位</div>
								<el-input v-model="form.position"></el-input>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="dialogBtnLan">
				<div class="dialogBtn" @click="signUp()">确认提交</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {enroll} from "../../api/canvass.js"
	import bottomArea from "../components/bottomArea.vue"
	export default {
		components: {
			bottomArea
		},
		data() {
			var checkName = (rule, value, callback) => {
			    if(value == null|| value == ''){
			        callback(new Error('联系人不能为空'));
			    }else{
			        callback();
			    }
			}
			var checkJob = (rule, value, callback) => {
			    if(value == null|| value == ''){
			        callback(new Error('职位不能为空'));
			    }else{
			        callback();
			    }
			}
			var checkTel = (rule, value, callback) => {
			    if(value == null|| value == ''){
			        callback(new Error('联系电话不能为空'));
			    }else{
					if(value.length!==11){
						callback(new Error('请输入11位手机号'));
					}else{
						callback();
					}
			    }
			}
			var checkCoName = (rule, value, callback) => {
			    if(value == null|| value == ''){
			        callback(new Error('公司名不能为空'));
			    }else{
			        callback();
			    }
			}
			return {
				scrollFlag: false,
				open: false,
				form: {
					companyName: null,
					name: null,
					tel: null,
					position: null,
				},
				platFormPic:0,
				platFormPic1:0,
				platFormPic2:0,
				showPlatFormPic:true,
				showPlatFormPic1:true,
				showPlatFormPic2:true,
				rules: {
					name: [
					    { validator: checkName, trigger: 'blur' }
					],
					companyName: [
					    { validator: checkCoName, trigger: 'blur' }
					],
					position: [
					    { validator: checkJob, trigger: 'blur' }
					],
					tel: [
					    { validator: checkTel, trigger: 'blur' }
					],
				}
			}
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll() {
				let _this = this;
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// console.log(scrollTop)
				if (scrollTop) {
					_this.scrollFlag = true
				} else {
					_this.scrollFlag = false
				}
			},
			openDialog() {
				this.open = true
			},
			cancel(){
				this.form = {
					companyName: null,
					name: null,
					tel: null,
					position: null,
				}
				this.open = false
			},
			signUp(){
				this.$refs["form"].validate(valid => {
					if (valid) {
						enroll(this.form).then(res => {
							if (res.code == 200) {
								this.$message({
									message: '提交成功，我们稍后会与您联系',
									type: 'success'
								});
								this.cancel()
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						this.$message.error('请完整填写信息');
					}
				});
			},
			jumpToIndex(){
				this.$router.push({
					name: 'index',
					params: {}
				});
			},
			changeStyle(type){
				this.platFormPic = type
				this.showPlatFormPic = false
				this.showPlatFormPic = true
			},
			changeStyle1(type){
				this.platFormPic1 = type
				this.showPlatFormPic1 = false
				this.showPlatFormPic1 = true
			},
			changeStyle2(type){
				this.platFormPic2 = type
				this.showPlatFormPic2 = false
				this.showPlatFormPic2 = true
			}
		}
	}
</script>

<style  scoped="scoped">
	html,
	body,
	#canvass {
		width: 100%;
		height: 100%;
		text-align: left;
	}

	.ruzhuBtn {
		position: absolute;
		width: 14.6%;
		top: 40%;
		left: 30%;
		cursor: pointer;
	}

	.section2-titleLan {
		width: 100%;
		height: 108px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.section2-title {
		margin-top: 53px;
		font-size: 26px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #333333;
	}

	.section2-line {
		width: 28px;
		height: 2px;
		background: #467CFD;
		margin-top: 16px;
	}

	.section2Area {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 34px;
	}

	.section2Pic {
		width: 560px;
	}

	.section3Area {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 84px;
	}

	.section3SmallArea {
		width: 1230px;
		display: flex;
		justify-content: center;
	}

	.section3Box {
		width: 600px;
		height: 448px;
		background: #FFFFFF;
		border-radius: 10px;
		display: flex;
	}

	.section3BoxLeft {
		width: 170px;
		height: 448px;
		position: relative;
	}
	.section3Img{
		width: 73.125rem;
		height: 27.375rem;
	}

	.section3BoxImg {
		position: absolute;
		width: 70px;
		height: 70px;
		top: 26px;
		left: 64px;
	}

	.section3BoxImg1 {
		position: absolute;
		width: 70px;
		height: 60px;
		top: 35px;
		left: 64px;
	}

	.section3BoxRight {
		width: 430px;
		height: 448px;
		display: flex;
		flex-direction: column;
	}

	.section3RightTitle {
		text-align: left;
		margin-top: 30px;
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #010101;
	}

	.section3RighttxtArea {
		width: 350px;
		display: flex;
		flex-direction: column;
	}

	.section3RighttxtLan {
		width: 100%;
		margin-top: 32px;
		display: flex;
	}

	.section3RighttxtLan1 {
		width: 100%;
		margin-top: 20px;
		display: flex;
	}

	.section3Righttxt {
		text-align: left;
		width: 370px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #060001;
		line-height: 22px;
	}

	.section4Area {
		width: 100%;
		margin-top: 30px;
		padding-bottom: 80px;
		display: flex;
		justify-content: center;
		/* align-items: center; */
	}

	.section4SmallArea {
		width: 75rem;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		/* height: 600px; */
	}

	.section4Box {
		/* float: left;
		margin-right: 1.6%;
		margin-bottom: 20px;
		width: 31.2%;
		height: 40%;
		border: 2px solid #467CFD;
		border-radius: 10px;
		display: flex;
		flex-direction: column; */
		/* background-image: url("../assets/logo.png"); */
		width: 24.1875rem;
		height: 13.875rem;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		align-items: center;
		/* & > :hover {
		    width: 24.1875rem;
		    height: 13.875rem;
		    background-image: url("../../static/canvasPic/img1.png");
		} */
	}

	.section4Box:hover{
		width: 24.1875rem;
		height: 13.875rem;
		background-image: url("../../static/canvasPic/img1.png");
	}
	
	.section4pic1{
		margin-top: 2.25rem;
		width: 4.625rem;
		height: 4.0625rem;
	}
	
	/* .section4pic1 {
		width: 12.7%;
		mode:widthFix;
		margin-left: 45%;
		margin-top: 21%
	} */

	.section4pic2 {
		margin-top: 2.25rem;
		width: 4.0625rem;
		height: 4.0625rem;
	}

	.section4pic3 {
		margin-top: 2.25rem;
		width: 4.0625rem;
		height: 4.0625rem;
	}

	.section4pic4 {
		width: 12.7%;
		mode:widthFix;
		margin-left: 45%;
		margin-top: 21%;
	}

	.section4pic5 {
		width: 12.7%;
		mode:widthFix;
		margin-left: 45%;
		margin-top: 21%;
	}

	.section4pic6 {
		width: 12.7%;
		mode:widthFix;
		margin-left: 45%;
		margin-top: 21%;
	}

	.section4txt {
		width: 18.75rem;
		text-align: center;
		/* margin-left: 53px; */
		margin-top: 40px;
		font-size: 22px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #3D3D3D;
	}
	
	.section4txt1 {
		width: 18.75rem;
		text-align: center;
		/* margin-left: 53px; */
		margin-top: 40px;
		font-size: 22px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	.section5Area {
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.section5SmallArea {
		width: 90.625rem;
		/* height: 210px; */
		display: flex;
		justify-content: space-between;
	}

	.section5Box {
		/* margin-right: 1.6%; */
		/* margin-bottom: 20px;
		width: 31%;
		height:100%;
		background: #FFFFFF;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		box-shadow: 0px 0px 12px #F4F6F9; */
		width: 21.875rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 50px;
		
	}

	.section5Pic1 {
		width: 13.375rem;
		height: 13.375rem;
	}

	.section5Pic2 {
		width: 24%;
		mode:widthFix;
		/* height: 35%; */
		margin-left: 40%;
		margin-top: 50px;
	}

	.section5Pic3 {
		width: 30.5%;
		mode:widthFix;
		/* height: 35%; */
		margin-left: 37%;
		margin-top: 50px;
	}

	.section5txt {
		width: 100%;
		text-align: center;
		margin-top: 14px;
		font-size: 30px;
		font-family: Source Han Sans CN;
		font-weight: 500;
		color: #222222;
	}
	.section5txt1 {
		width: 100%;
		text-align: center;
		margin-top: 20px;
		font-size: 22px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #666666;
	}

	.section6Area {
		margin-top: 52px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.section6SmallArea {
		width: 1230px;
	}

	.section6Box {
		float: left;
		width: 592px;
		height: 372px;
		background: #FFFFFF;
		border-radius: 10px;
		box-shadow: 0px 0px 12px #F4F6F9;
		display: flex;
		flex-direction: column;
		margin-right: 22px;
		margin-bottom: 33px;
	}

	.section6Pic1 {
		width: 301px;
		height: 178px;
		margin-top: 80px;
		margin-left: 144px;
	}

	.section6txt1 {
		width: 100%;
		text-align: center;
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #010101;
		margin-top: 39px;
	}

	.section6Pic2 {
		width: 306px;
		height: 210px;
		margin-top: 59px;
		margin-left: 144px;
	}

	.section6txt2 {
		width: 100%;
		text-align: center;
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #010101;
		margin-top: 28px;
	}

	.section7Area {
		margin-top: 52px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.section7SmallArea {
		width: 1230px;
	}

	.section7Box {
		float: left;
		width: 592px;
		height: 422px;
		background: #FFFFFF;
		border-radius: 10px;
		box-shadow: 0px 0px 12px #F4F6F9;
		display: flex;
		flex-direction: column;
		/* justify-content: center; */
		align-items: center;
		margin-right: 22px;
		margin-bottom: 33px;
	}

	.section7Pic {
		margin-top: 77px;
		width: 100px;
		height: 100px;
	}

	.section7txt1 {
		margin-top: 24px;
		font-size: 24px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #010101;
	}

	.section7txt2 {
		margin-top: 107px;
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #010101;
	}

	.dialogClass {
		border-radius: 20px;
	}

	.dialogLine {
		width: 100%;
		height: 3px;
		background: #467CFD;
	}

	.dialogBox {
		width: 100%;
		height: 53px;
		background: #FFFFFF;
		border: 2px solid #CCDBFF;
		border-radius: 4px;
		position: relative;
		display: flex;
	}

	.inputTitle {
		width: 80px;
		height: 53px;
		line-height: 53px;
		font-size: 14px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
		text-align: center;
	}

	/deep/.el-input__inner {
		width: 300px;
		height: 53px;
		line-height: 53px;
		border: 0;
	}
	.dialogBtnLan{
		width: 100%;
		height: 59px;
		margin-top: 42px;
		margin-bottom: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.dialogBtn{
		width: 241px;
		height: 59px;
		background: linear-gradient(90deg, #5E9EF6, #317AE5);
		border-radius: 8px;
		text-align: center;
		line-height: 59px;
		font-size: 14px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
		cursor: pointer;
	}
	.section7PicLan{
		width: 330px;
		margin-top: 40px;
		display: flex;
		justify-content: space-between;
	}
	.section7PicLan1{
		width: 330px;
		margin-top: 40px;
		display: flex;
		justify-content: center;
	}
	.section7PicLanBox{
		width: 109px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.section7PicBoxImg{
		width: 100%;
		mode:widthFix;
	}
	.section7PicBoxtxt{
		margin-top: 6px;
		width: 100%;
		text-align: center;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #010101;
	}
</style>
